import Swiper, { Navigation } from 'swiper';
import { uuid } from '../helpers/uuid';

export default class SliderFinn {
    static initAll() {
        return new SliderFinn();
    }
    constructor() {
		const sliders = document.querySelectorAll('.slider-finn');

        sliders.forEach((slider) => {
            const id = 'slider-' + uuid();
            slider.setAttribute('id', id);

			const config = {
				modules: [Navigation],
				slidesPerView: 1,
				spaceBetween: 40,
				autoHeight: true,
				simulateTouch: true,
				grabCursor: true,
				navigation: {
					prevEl: `#${id} .swiper-button-prev`,
					nextEl: `#${id} .swiper-button-next`,
				},
			};

            new Swiper(slider, config);
        })
    }
}
